var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/components/feature/connections/NotForSale/DualHookShowcaseUpsell/DualHookShowcaseUpsellTemplate.jsx";

import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import marked from 'marked';
import { Heading, Button, Paragraph, token, spaceMixin, Popover, TextButton, Text, Flex, mediaMixin } from '@zillow/constellation';
import { ShowcaseMarkDownTextWithToolTip } from './ShowcaseMarkDownTextWithToolTip';
import { formatEarnings } from '../../../../../utils/currencyFormatting';
var AutoMarginWrapper = styled.div.withConfig({
  displayName: "DualHookShowcaseUpsellTemplate__AutoMarginWrapper",
  componentId: "sc-460l9-0"
})(["max-width:584px;margin:0 auto;"]);
var StyledWrapper = styled.div.withConfig({
  displayName: "DualHookShowcaseUpsellTemplate__StyledWrapper",
  componentId: "sc-460l9-1"
})(["background-color:", ";text-align:center;margin:", " ", " 0;", ""], token('colors.white'), spaceMixin(2), spaceMixin(2), mediaMixin('sm_lte', css(["margin:", " ", " 0;"], spaceMixin(1), spaceMixin(1))));
var StyledHeader = styled(Flex).withConfig({
  displayName: "DualHookShowcaseUpsellTemplate__StyledHeader",
  componentId: "sc-460l9-2"
})(["width:100%;text-align:center;"]);
var HookContainer = styled(Flex).withConfig({
  displayName: "DualHookShowcaseUpsellTemplate__HookContainer",
  componentId: "sc-460l9-3"
})(["background-color:", ";height:auto;min-height:141px;max-width:284px;border-radius:24px;"], token('colors.blue200'));
var HookMarkdownTextWrapper = styled(Flex).withConfig({
  displayName: "DualHookShowcaseUpsellTemplate__HookMarkdownTextWrapper",
  componentId: "sc-460l9-4"
})(["max-width:168px;"]);
var FullWidthButton = styled(Button).withConfig({
  displayName: "DualHookShowcaseUpsellTemplate__FullWidthButton",
  componentId: "sc-460l9-5"
})(["width:100%;"]);

var DualHookShowcaseUpsellTemplate = function DualHookShowcaseUpsellTemplate(_ref) {
  var upsellTitleText = _ref.upsellTitleText,
      upsellSubtitleText = _ref.upsellSubtitleText,
      firstHookTitle = _ref.firstHookTitle,
      firstHookMarkdownText = _ref.firstHookMarkdownText,
      firstHookPopoverTitleText = _ref.firstHookPopoverTitleText,
      firstHookPopoverBodyText = _ref.firstHookPopoverBodyText,
      firstHookPopoverButtonText = _ref.firstHookPopoverButtonText,
      firstHookPopoverButtonRedirectUrl = _ref.firstHookPopoverButtonRedirectUrl,
      firstHookValueZestimatePercent = _ref.firstHookValueZestimatePercent,
      secondHookTitle = _ref.secondHookTitle,
      secondHookMarkdownText = _ref.secondHookMarkdownText,
      secondHookPopoverTitleText = _ref.secondHookPopoverTitleText,
      secondHookPopoverBodyText = _ref.secondHookPopoverBodyText,
      secondHookPopoverButtonText = _ref.secondHookPopoverButtonText,
      secondHookPopoverButtonRedirectUrl = _ref.secondHookPopoverButtonRedirectUrl,
      secondHookValue = _ref.secondHookValue,
      actionText = _ref.actionText,
      standingOfferPrice = _ref.standingOfferPrice,
      onClickUpsellButton = _ref.onClickUpsellButton;
  var earnings = formatEarnings(parseInt(standingOfferPrice, 10) * parseFloat(firstHookValueZestimatePercent, 10));
  /* set width to prevent IE11 word wrap bug for flex children */

  var titleNode = upsellTitleText ? /*#__PURE__*/React.createElement(Heading, {
    level: 4,
    mediaQuery: {
      md: {
        marginTop: 'sm'
      }
    },
    style: {
      width: '100%',
      margin: '8px 0px'
    },
    dangerouslySetInnerHTML: {
      __html: marked.parseInline(upsellTitleText)
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 84,
      columnNumber: 9
    }
  }) : null;
  var firstHookPopover = /*#__PURE__*/React.createElement(Popover // Never show full screen popover modal
  , {
    modal: false,
    header: /*#__PURE__*/React.createElement(Heading, {
      level: "6",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 101,
        columnNumber: 21
      }
    }, firstHookPopoverTitleText),
    body: /*#__PURE__*/React.createElement("div", {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 103,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Paragraph, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 104,
        columnNumber: 21
      }
    }, firstHookPopoverBodyText), /*#__PURE__*/React.createElement(TextButton, {
      as: "a",
      href: firstHookPopoverButtonRedirectUrl,
      target: "_blank",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 105,
        columnNumber: 21
      }
    }, firstHookPopoverButtonText)),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 98,
      columnNumber: 9
    }
  });
  var secondHookPopover = /*#__PURE__*/React.createElement(Popover // Never show full screen popover modal
  , {
    modal: false,
    header: /*#__PURE__*/React.createElement(Heading, {
      level: "6",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 117,
        columnNumber: 21
      }
    }, secondHookPopoverTitleText),
    body: /*#__PURE__*/React.createElement("div", {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 119,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Paragraph, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 120,
        columnNumber: 21
      }
    }, secondHookPopoverBodyText), /*#__PURE__*/React.createElement(TextButton, {
      as: "a",
      href: secondHookPopoverButtonRedirectUrl,
      target: "_blank",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 121,
        columnNumber: 21
      }
    }, secondHookPopoverButtonText)),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 114,
      columnNumber: 9
    }
  });
  var firstHookMarkdownTextNode = /*#__PURE__*/React.createElement(ShowcaseMarkDownTextWithToolTip, {
    markdownTextInput: firstHookMarkdownText,
    bodyTooltipPopover: firstHookPopover,
    fontType: "finePrint",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 130,
      columnNumber: 9
    }
  });
  var secondHookMarkdownTextNode = /*#__PURE__*/React.createElement(ShowcaseMarkDownTextWithToolTip, {
    markdownTextInput: secondHookMarkdownText,
    bodyTooltipPopover: secondHookPopover,
    fontType: "finePrint",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 138,
      columnNumber: 9
    }
  });
  var action = /*#__PURE__*/React.createElement(FullWidthButton, {
    buttonType: "primary",
    onClick: onClickUpsellButton,
    marginTop: "md",
    marginBottom: "xs",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 146,
      columnNumber: 9
    }
  }, actionText);
  return /*#__PURE__*/React.createElement(AutoMarginWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 157,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(StyledWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 158,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(StyledHeader, {
    display: "flex",
    flexDirection: "column",
    marginBottom: "sm",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 159,
      columnNumber: 17
    }
  }, titleNode, /*#__PURE__*/React.createElement(Text, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 161,
      columnNumber: 21
    }
  }, upsellSubtitleText)), /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    flexDirection: "row",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 163,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(HookContainer, {
    display: "flex",
    justifyContent: "flex-start",
    flexGrow: 24,
    flexBasis: 0,
    flexDirection: "column",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 164,
      columnNumber: 21
    }
  }, /*#__PURE__*/React.createElement(Text, {
    fontType: "bodySmallHeading",
    fontColor: "blue400",
    marginX: "xs",
    marginTop: "md",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 171,
      columnNumber: 25
    }
  }, firstHookTitle), /*#__PURE__*/React.createElement(Text, {
    fontType: "h4",
    marginX: 0.5,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 179,
      columnNumber: 25
    }
  }, "+", earnings), /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    justifyContent: "center",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 182,
      columnNumber: 25
    }
  }, /*#__PURE__*/React.createElement(HookMarkdownTextWrapper, {
    display: "flex",
    marginTop: 0.5,
    marginX: "xs",
    marginBottom: "xs",
    justifyContent: "center",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 183,
      columnNumber: 29
    }
  }, firstHookMarkdownTextNode))), /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    flexGrow: 1,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 194,
      columnNumber: 21
    }
  }), /*#__PURE__*/React.createElement(HookContainer, {
    display: "flex",
    justifyContent: "flex-start",
    flexGrow: 24,
    flexBasis: 0,
    flexDirection: "column",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 195,
      columnNumber: 21
    }
  }, /*#__PURE__*/React.createElement(Text, {
    fontType: "bodySmallHeading",
    fontColor: "blue400",
    marginX: "xs",
    marginTop: "md",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 202,
      columnNumber: 25
    }
  }, secondHookTitle), /*#__PURE__*/React.createElement(Text, {
    fontType: "h4",
    marginX: 0.5,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 210,
      columnNumber: 25
    }
  }, secondHookValue), /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    justifyContent: "center",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 213,
      columnNumber: 25
    }
  }, /*#__PURE__*/React.createElement(HookMarkdownTextWrapper, {
    display: "flex",
    marginTop: 0.5,
    marginX: "xs",
    marginBottom: "xs",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 214,
      columnNumber: 29
    }
  }, secondHookMarkdownTextNode)))), action));
};

DualHookShowcaseUpsellTemplate.propTypes = process.env.NODE_ENV !== "production" ? {
  standingOfferPrice: PropTypes.string.isRequired,
  firstHookTitle: PropTypes.string.isRequired,
  firstHookMarkdownText: PropTypes.string.isRequired,
  firstHookPopoverTitleText: PropTypes.string.isRequired,
  firstHookPopoverBodyText: PropTypes.string.isRequired,
  firstHookPopoverButtonText: PropTypes.string.isRequired,
  firstHookPopoverButtonRedirectUrl: PropTypes.string.isRequired,
  firstHookValueZestimatePercent: PropTypes.string.isRequired,
  secondHookTitle: PropTypes.string.isRequired,
  secondHookMarkdownText: PropTypes.string.isRequired,
  secondHookPopoverTitleText: PropTypes.string.isRequired,
  secondHookPopoverBodyText: PropTypes.string.isRequired,
  secondHookPopoverButtonText: PropTypes.string.isRequired,
  secondHookPopoverButtonRedirectUrl: PropTypes.string.isRequired,
  secondHookValue: PropTypes.string.isRequired,
  onClickUpsellButton: PropTypes.func.isRequired,
  upsellTitleText: PropTypes.string.isRequired,
  upsellSubtitleText: PropTypes.string.isRequired,
  actionText: PropTypes.string.isRequired
} : {};
export default DualHookShowcaseUpsellTemplate;